import React, { useEffect } from "react";

const GTranslate: React.FC = () => {
  useEffect(() => {
    //@ts-ignore
    window.gtranslateSettings = {
      default_language: "bg", // 👉 Оригиналният език на сайта
      detect_browser_language: false, // 👉 Не гледаме браузъра
      languages: ["fr", "en", "bg", "it", "es", "tr", "ru", "de", "pl"],
      globe_color: "#66aaff",
      wrapper_selector: ".gtranslate_wrapper",
      horizontal_position: "right",
      vertical_position: "top",
    };

    const script = document.createElement("script");
    script.src = "https://cdn.gtranslate.net/widgets/latest/globe.js";
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="flex justify-center items-center mt-6 w-full">
      <div className="gtranslate_wrapper" style={{ textAlign: "center" }}></div>
    </div>
  );
};

export default GTranslate;
